import { render, staticRenderFns } from "./AddressManagement.vue?vue&type=template&id=caae0b42&scoped=true"
import script from "./AddressManagement.vue?vue&type=script&lang=js"
export * from "./AddressManagement.vue?vue&type=script&lang=js"
import style0 from "./AddressManagement.vue?vue&type=style&index=0&id=caae0b42&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caae0b42",
  null
  
)

export default component.exports